import { render, staticRenderFns } from "./touchpointDashboard.vue?vue&type=template&id=48e21d1c&lang=true"
import script from "./touchpointDashboard.vue?vue&type=script&lang=js"
export * from "./touchpointDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports